// ─── Constants ────────────────────────────────────────────────────────────────

const SELECTORS = {
  select: "select",
};

// ─── Class ────────────────────────────────────────────────────────────────────

export class DropDownLinkList {
  private el: HTMLElement;
  private abortController: AbortController;

  constructor(el: HTMLElement) {
    this.el = el;
    this.abortController = new AbortController();
  }

  init(): void {
    const { signal } = this.abortController;

    this.el
      .querySelector<HTMLSelectElement>(SELECTORS.select)
      ?.addEventListener(
        "change",
        (e) => {
          const href = (e.currentTarget as HTMLSelectElement).value;
          if (href) window.location.href = href;
        },
        { signal },
      );
  }

  destroy(): void {
    this.abortController.abort();
  }

  // ─── Static bootstrap ───────────────────────────────────────────────────────

  static initAll(root: Document | HTMLElement = document): void {
    root
      .querySelectorAll<HTMLElement>('[data-component="dropdown-linklist"]')
      .forEach((el) => {
        new DropDownLinkList(el).init();
      });
  }
}
